/* === Main Product (puro JS) === */

/* Tabs (Descrição/Ficha) */
window.openTab = function openTab(evt, tabId) {
  const tabs = document.querySelectorAll('.tab-content');
  const links = document.querySelectorAll('.tab-link');
  tabs.forEach(t => (t.style.display = 'none'));
  links.forEach(l => l.classList.remove('active'));
  const el = document.getElementById(tabId);
  if (el) el.style.display = 'block';
  if (evt && evt.currentTarget) evt.currentTarget.classList.add('active');
};

/* “Cor selecionada” ao trocar variação */
document.addEventListener('DOMContentLoaded', () => {
  const corTextoEl = document.getElementById('cor-texto');
  function atualizarCorSelecionada() {
    const inputSelecionado = document.querySelector('input[type="radio"][name^="Cor"]:checked');
    if (corTextoEl) corTextoEl.textContent = inputSelecionado ? inputSelecionado.value : 'Cor não identificada';
  }
  atualizarCorSelecionada();
  document.querySelectorAll('input[type="radio"][name^="Cor"]').forEach(input => {
    input.addEventListener('change', atualizarCorSelecionada);
  });
  document.body.addEventListener('click', () => setTimeout(atualizarCorSelecionada, 50));
});

/* Botão de copiar cupom (delegação) */
document.addEventListener('click', e => {
  const btn = e.target.closest('.cupom-copy');
  if (!btn) return;
  const code = btn.getAttribute('data-cupom') || '';
  if (!navigator.clipboard) return;
  navigator.clipboard.writeText(code).then(() => {
    const old = btn.textContent;
    btn.textContent = 'Copiado';
    setTimeout(() => (btn.textContent = old), 1500);
  });
});

/* Clique nas avaliações leva para Descrição */
document.addEventListener('DOMContentLoaded', () => {
  const ratingBox = document.querySelector('.produto-avaliacoes');
  const tabDescricaoBtn = document.querySelector('.tab-link[onclick*="descricao"]');
  const contentDescricao = document.getElementById('descricao');
  if (ratingBox && tabDescricaoBtn && contentDescricao) {
    ratingBox.addEventListener('click', () => {
      if (!tabDescricaoBtn.classList.contains('active')) {
        document.querySelectorAll('.tab-link').forEach(btn => btn.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach(tab => (tab.style.display = 'none'));
        tabDescricaoBtn.classList.add('active');
        contentDescricao.style.display = 'block';
      }
      setTimeout(() => contentDescricao.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    });
  }
});

/* Wishlist (limpeza leve) */
document.addEventListener('DOMContentLoaded', () => {
  const kill = () => document.querySelectorAll('.uwl-notification, .uwl-toast, .uwl-popup, .uwl-notification.slide-left').forEach(el => el.remove());
  kill();
  let tries = 0;
  const iv = setInterval(() => { kill(); if (++tries >= 5) clearInterval(iv); }, 400);
});

/* Newsletter popup helpers (puro JS) */
window.abrirPopupNewsletter = function () {
  const el = document.getElementById('popup-newsletter'); if (el) el.style.display = 'flex';
};
window.fecharPopupNewsletter = function () {
  const el = document.getElementById('popup-newsletter'); if (el) el.style.display = 'none';
};
window.enviarCadastro = function () {
  const telefone = document.getElementById('popup-telefone')?.value;
  const email = document.getElementById('popup-email')?.value;
  if (!telefone || !email) { alert('Preencha todos os campos'); return; }
  document.getElementById('popup-newsletter-form').style.display = 'none';
  document.getElementById('popup-newsletter-sucesso').style.display = 'block';
};
window.copiarCupom = function () {
  if (!navigator.clipboard) return;
  navigator.clipboard.writeText('LESSUL').then(() => window.fecharPopupNewsletter());
};
